import React from 'react';

const About = () => {
  return (
    <div>
      <h2>About us page</h2>
    </div>
  );
};

export default About;
